/**
 * Block 14 «Раскрой» — общие хелперы растеризации SVG для PDF (вынесены из
 * `cutPdf.ts`, чтобы переиспользовать в `labelsPdf.ts`). Паттерн
 * `renderToStaticMarkup` → `<svg>` → PNG через canvas → `jsPDF.addImage`.
 */

/** Извлечь первый `<svg …>…</svg>` из markup (defensive — на случай обёртки). */
export function extractSvg(markup: string): string {
  const start = markup.indexOf('<svg');
  const end = markup.lastIndexOf('</svg>');
  if (start < 0 || end < 0) return markup;
  return markup.slice(start, end + '</svg>'.length);
}

/** SVG-строка → PNG dataURL через canvas (паттерн svgToPng, project-io.js). */
export function svgToPng(svgString: string, w: number, h: number): Promise<string> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = w;
      canvas.height = h;
      const ctx = canvas.getContext('2d');
      if (!ctx) {
        reject(new Error('canvas 2d context недоступен'));
        return;
      }
      ctx.fillStyle = 'white';
      ctx.fillRect(0, 0, w, h);
      ctx.drawImage(img, 0, 0, w, h);
      resolve(canvas.toDataURL('image/png'));
    };
    img.onerror = () => reject(new Error('Не удалось сконвертировать SVG карты в PNG'));
    img.src = 'data:image/svg+xml;base64,' + btoa(unescape(encodeURIComponent(svgString)));
  });
}
